import FormControl from "@material-ui/core/FormControl";
import ListSubheader from "@material-ui/core/ListSubheader";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withTheme } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import HelpIcon from "@material-ui/icons/HelpOutline";
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { languages } from "../../../constants/languages";
import DeleteDiaSpotContainer from "../../../containers/settings/slideshow/DeleteDiaSpotContainer";
import DiaPhotoContainer from "../../../containers/settings/slideshow/DiaPhotoContainer";
import DiaTextContainer from "../../../containers/settings/slideshow/DiaTextContainer";
import EditPouleSpotContainer from "../../../containers/settings/slideshow/EditPouleSpotContainer";
import WidthMenu from "./WidthMenu";

class DiaElement extends React.Component {
  render() {
    const structureElement = this.props.structureElement;
    const i = this.props.index;

    let elementType = "poules";
    if (structureElement.isBracket) {
      elementType = "brackets";
    }
    return (
      <Draggable
        key={
          structureElement.id +
          (structureElement.diaNum !== undefined
            ? structureElement.diaNum.toString()
            : "")
        }
        draggableId={
          structureElement.id +
          (structureElement.diaNum !== undefined
            ? structureElement.diaNum.toString()
            : "")
        }
        index={i}
        isDragDisabled={this.props.dia.isPSD}
      >
        {(provided, snapshot) => (
          <div>
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <div
                className={
                  this.props.isDraggingWithinDia === null ||
                  this.props.isDraggingWithinDia === this.props.dia.id
                    ? "hoverItem"
                    : ""
                }
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 3,
                  border: 0,
                }}
              >
                <div
                  style={{
                    width: "90%",
                    paddingLeft: 10,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {!this.props.dia.isPSD &&
                    structureElement.label +
                      (structureElement.isSponsors &&
                      this.props.sponsors.length > 1
                        ? " (" +
                          this.props.blockNames[
                            this.props.dia[
                              "sponsorGroup" + structureElement.sponsorNum
                            ] || 0
                          ] +
                          ")"
                        : "")}
                  {structureElement.isSponsors &&
                    (
                      this.props.tournament[
                        "sponsors" +
                          (this.props.dia[
                            "sponsorGroup" + structureElement.sponsorNum
                          ]
                            ? this.props.dia[
                                "sponsorGroup" + structureElement.sponsorNum
                              ]
                            : "")
                      ] || []
                    ).length > 12 && (
                      <Tooltip title={languages.present.sponsorsDiaWarning}>
                        <ErrorIcon
                          style={{
                            height: 15,
                            width: 15,
                            marginLeft: 5,
                            position: "relative",
                            top: 2,
                          }}
                        />
                      </Tooltip>
                    )}
                  {structureElement.isRanking && (
                    <Tooltip title={languages.formatString(languages.results.rankingDescription, 
                      this.props.tournament.individualPlayers 
                      ? languages.teams.playersLow
                      : languages.tournament.teamsLow
                      )}>
                      <HelpIcon
                        style={{
                          height: 15,
                          width: 15,
                          marginLeft: 5,
                          position: "relative",
                          top: 2,
                        }}
                      />
                    </Tooltip>
                  )}
                  {this.props.dia.isPSD && languages.present.psdAd}
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {structureElement.isTeamLayouts && (
                      <FormControl
                        size="small"
                        variant="outlined"
                        style={{ marginRight: 5 }}
                      >
                        <Select
                          style={{ height: 30 }}
                          value={this.props.tournament.teamLayoutsSort || "0"}
                          onChange={this.props.handleTeamLayoutsSortChange}
                        >
                          <ListSubheader>{languages.teams.sort}</ListSubheader>
                          <MenuItem value="0">
                            {languages.teams.sortByName}
                          </MenuItem>
                          <MenuItem value="1">
                            {languages.teams.sortByPlayerName}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}

                    {structureElement.isText && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name: "widthDiaText" + structureElement.textNum,
                            id: "widthDiaText" + structureElement.textNum,
                          }}
                        />
                        <DiaTextContainer
                          tournament={this.props.tournament}
                          dia={this.props.dia}
                          structureElements={this.props.structureElements}
                          edit={true}
                          structureElement={structureElement}
                        />
                      </div>
                    )}
                    {structureElement.isPicture && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name: "widthDiaPhoto" + structureElement.photoNum,
                            id: "widthDiaPhoto" + structureElement.photoNum,
                          }}
                          disabled={this.props.dia.isPSD}
                        />
                        <DiaPhotoContainer
                          tournament={this.props.tournament}
                          dia={this.props.dia}
                          structureElements={this.props.structureElements}
                          edit={true}
                          user={this.props.user}
                          userData={this.props.userData}
                          userStatus={this.props.userStatus}
                          tournamentStatus={this.props.tournamentStatus}
                          structureElement={structureElement}
                        />
                      </div>
                    )}
                    {structureElement.isQRCode && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name: "widthQRCode",
                            id: "widthQRCode",
                          }}
                        />
                      </div>
                    )}
                    {structureElement.isDressingRooms && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name:
                              "widthDiaDressingRooms" +
                              (structureElement.divisionId === "0"
                                ? ""
                                : structureElement.divisionId) +
                              structureElement.layoutNum.toString(),
                            id:
                              "widthDiaDressingRooms" +
                              (structureElement.divisionId === "0"
                                ? ""
                                : structureElement.divisionId) +
                              structureElement.layoutNum.toString(),
                          }}
                        />
                      </div>
                    )}
                    {structureElement.isTeamLayouts && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "0"}
                          handleWidthChange={this.props.handleWidthChange}
                          enable25width
                          inputProps={{
                            name:
                              "widthDiaTeamLayouts" +
                              (structureElement.divisionId === "0"
                                ? ""
                                : structureElement.divisionId) +
                              structureElement.layoutNum.toString(),
                            id:
                              "widthDiaTeamLayouts" +
                              (structureElement.divisionId === "0"
                                ? ""
                                : structureElement.divisionId) +
                              structureElement.layoutNum.toString(),
                          }}
                        />
                      </div>
                    )}
                    {structureElement.isUpcomingMatches && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name:
                              "widthDiaUpcomingMatches" +
                              structureElement.sportParkId,
                            id:
                              "widthDiaUpcomingMatches" +
                              structureElement.sportParkId,
                          }}
                        />
                      </div>
                    )}

                    {structureElement.isRecentResults && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name:
                              "widthDiaRecentResults" +
                              structureElement.sportParkId,
                            id:
                              "widthDiaRecentResults" +
                              structureElement.sportParkId,
                          }}
                        />
                      </div>
                    )}

                    {structureElement.isRanking && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name:
                              "widthDiaRanking" +
                              structureElement.divisionId +
                              structureElement.rankingNum,
                            id:
                              "widthDiaRanking" +
                              structureElement.divisionId +
                              structureElement.rankingNum,
                          }}
                        />
                      </div>
                    )}

                    {structureElement.isPlayerStats && (
                      <div>
                        <WidthMenu
                          value={structureElement.width || "3"}
                          handleWidthChange={this.props.handleWidthChange}
                          inputProps={{
                            name:
                              "widthDiaPlayerStats" +
                              structureElement.divisionId +
                              "_" +
                              structureElement.statKey,
                            id:
                              "widthDiaPlayerStats" +
                              structureElement.divisionId +
                              "_" +
                              structureElement.statKey,
                          }}
                        />
                      </div>
                    )}

                    {(elementType === "poules" ||
                      (elementType === "brackets" &&
                        structureElement[
                          "bracketRoundDia" +
                            (structureElement.diaNum !== undefined
                              ? structureElement.diaNum
                              : "")
                        ] > 16)) &&
                      !structureElement.isSponsors &&
                      !structureElement.isText &&
                      !structureElement.isPicture &&
                      !structureElement.isQRCode &&
                      !structureElement.isDressingRooms &&
                      !structureElement.isTeamLayouts &&
                      !structureElement.isUpcomingMatches &&
                      !structureElement.isRecentResults &&
                      !structureElement.isRanking &&
                      !structureElement.isPlayerStats && (
                        <EditPouleSpotContainer
                          tournament={this.props.tournament}
                          elementType={elementType}
                          elementId={structureElement.id}
                          structureElement={structureElement}
                          dia={this.props.dia}
                        />
                      )}

                    <DeleteDiaSpotContainer
                      tournament={this.props.tournament}
                      elementType={elementType}
                      elementId={structureElement.id}
                      structureElement={structureElement}
                      dia={this.props.dia}
                    />
                  </div>
                </div>
              </div>
            </div>
            {provided.placeholder}
          </div>
        )}
      </Draggable>
    );
  }
}

export default withTheme(DiaElement);
